export default __webpack_public_path__ + "static/media/redencao_ilustration_large.e1a5b0c5.jpg";